module.exports = __webpack_public_path__ + "img/network_logo.ac9d5611.jpg";